// @ts-nocheck

import app from "@/main";
import {DosyaEvraklarCevapRow, IDosyaEvrak} from "../uyap/DosyaEvraklar";
import * as xml2js from "xml2js";
import JSZip from "jszip";
import UyapTakipTalebiContent from "./UyapTakipTalebiContent";
import {AvukatIcraDosyalariTalep} from "../uyap/AvukatIcraDosyalari";
import EvrakIslemleri from "@/plugins/uyap-plugin/uyap/classes/EvrakIslemleri";
import FrontendTebligatPdfParser from "@/plugins/uyap-plugin/uyap/classes/FrontendTebligatPdfParser";

export default class TakipSenkronize {
    queueCount: number = 0;
    workingNumber: number = 0;

    async runQueryForSelectedItems(items: any[]): Promise<any[]> {
        const resultList: any[] = [];
        for (const item of items) {
            try {
                const takip = await app.$uyap.DosyaBul().run(item);
                const evrakIslemleri = new EvrakIslemleri();
                const kapaliTebligatlar: IDosyaEvrak[] = await evrakIslemleri.dosyaKapaliTebligatlar(takip.dosyaId);
                const borclular = await app.$uyap.DosyaBorclulari().run({
                    dosyaId: takip.dosyaId
                });
                console.log("borclular",borclular);
                for (const evrak of kapaliTebligatlar) {
                    try {
                        const evrakBlob = await app.$uyap.EvrakIndir().run({
                            dosyaId: takip.dosyaId,
                            evrakId: evrak.evrakId
                        });
                        console.log("evrakBlbo",evrakBlob);
                        //const fdata = new FormData();
                        //fdata.append("pdf", evrakBlob);
                        //const readedPdfResponse = await app.$http.post("/api/v1/tebligat-pdf-tara", fdata);
                        const parser = new FrontendTebligatPdfParser();
                        const readedPdfResponse = await parser.parse(evrakBlob, {
                            enableBarcodeScan: true,
                            enableOcr: true
                        });
                        const parsedData = readedPdfResponse?.data;

                        console.log("readedPdfResponse", readedPdfResponse);

                        if (!readedPdfResponse?.status || !parsedData?.barkodNo) {
                            console.warn("senkronize: barkod bulunamadı", {
                                dosyaId: takip.dosyaId,
                                evrakId: evrak.evrakId,
                                errors: readedPdfResponse?.errors
                            });
                            continue;
                        }
                        let barkodResponse = null;
                        if(parsedData.isETebligat == false){
                            barkodResponse = await app.$uyap.PttBarkodSorgula().run({
                                barkodNo: parsedData.barkodNo
                            });
                            if(barkodResponse.status == "error")
                                throw new Error(barkodResponse.message);
                        }
                        console.log("borclular",borclular);
                        const borclu = this.findBestBorcluMatch(
                            borclular,
                            parsedData.isKurum ? (parsedData.kurumAd || "") : (parsedData.adSoyad || ""),
                            parsedData.isKurum === true
                        );
                        if(borclu){
                            let kurum = null;
                            let kisi = null;
                            // if(borclu.isKurumBool === true)
                            //     kurum = await app.$uyap.KurumSorgulama().run({vergiNo:borclu.borcluBilgileri.vergiNo});
                            // else
                            //     kisi = await app.$uyap.KisiSorgula().run({tcKimlikNo:borclu.tcKimlikNo});

                            console.log("item",item);
                            await app.$http.post("/api/v1/tebligat-senkronize", {
                                takip_id: item.takip_id,
                                borclu: borclu.borcluBilgileri,
                                isKisi: borclu.isKisiBool,
                                isKurum: borclu.isKurumBool,
                                tebligatGonderimTarihi: evrak.onaylandigiTarih,
                                evrakAciklama: evrak.aciklama,
                                tebligat: parsedData,
                                // kisi: kisi,
                                // kurum: kurum,
                                barkodBilgileri:barkodResponse
                            });
                        }else{
                            throw new Error("Tebligat için borçlu eşleşmedi.")
                        }

                    } catch (innerError) {
                        console.warn("senkronize", innerError)
                    }
                }
                resultList.push({ dosya_esas_no: item.dosya_esas_no, status: "success", processedCount: kapaliTebligatlar.length });
            } catch (error) {
                console.error(error)
                resultList.push({ dosya_esas_no: item.dosya_esas_no, status: "error", message: error.message || String(error) });
            }
        }
        return resultList;
    }
    
    borcluBul(borclular: any[], borclu: any): any {
        // Borçlu bulma mantığı implementasyonu
        return borclular.find(b => 
            (b.borcluBilgileri.adi + " " + b.borcluBilgileri.soyadi) === borclu.adSoyad ||
            b.borcluBilgileri.kurumAdi === borclu.kurumAd
        );
    }

    private findBestBorcluMatch(borclular: any[], targetName: string, isKurum: boolean): any | null {
        if (borclular?.length === 1) {
            return borclular[0];
        }

        const target = this.normalizeName(targetName);
        if (!target || !borclular?.length) return null;

        let best: { item: any; score: number } | null = null;
        for (const item of borclular) {
            const sourceName = isKurum
                ? (item?.borcluBilgileri?.kurumAdi || "")
                : `${item?.borcluBilgileri?.adi || ""} ${item?.borcluBilgileri?.soyadi || ""}`;

            const normalized = this.normalizeName(sourceName);
            if (!normalized) continue;

            const score = this.scoreNameMatch(target, normalized);
            if (!best || score > best.score) {
                best = { item, score };
            }
        }

        return best ? best.item : null;
    }

    private normalizeName(value: string): string {
        return (value || "")
            .toLocaleLowerCase("tr-TR")
            .replace(/\([^)]*\)/g, " ")
            .replace(/[^a-zçğıöşü\s]/gi, " ")
            .replace(/\s+/g, " ")
            .trim();
    }

    private scoreNameMatch(target: string, candidate: string): number {
        if (target === candidate) return 1000;

        const targetTokens = new Set(target.split(" ").filter(Boolean));
        const candidateTokens = candidate.split(" ").filter(Boolean);
        if (candidateTokens.length === 0) return 0;

        let matches = 0;
        for (const token of candidateTokens) {
            if (targetTokens.has(token)) matches++;
        }

        const overlap = matches / Math.max(candidateTokens.length, 1);
        const prefixBonus = candidate.startsWith(target) || target.startsWith(candidate) ? 0.2 : 0;
        const lengthScore = 1 - Math.abs(target.length - candidate.length) / Math.max(target.length, candidate.length, 1);
        return overlap * 100 + prefixBonus * 100 + lengthScore * 20;
    }

    async runQueryLastOneWeek(): Promise<void> {
        try {
            let requestData = new AvukatIcraDosyalariTalep();
            requestData.dosyaAcilisTarihiStart = app.$uyapHelper.getDateNow(".", "day -7", false, true);
            requestData.dosyaAcilisTarihiEnd = app.$uyapHelper.getDateNow(".", "", false, true);
            let acikDosyalar = await app.$uyap.AvukatIcraDosyalari().run(requestData);
            this.queueCount = acikDosyalar.items.length;
            let key = 0;
            for (const dosya of acikDosyalar.items) {
                this.workingNumber = key + 1;
                let evraklar = await app.$uyap.DosyaEvraklar().run({
                    dosyaId: dosya.dosyaId
                });
                let takipTalebi = evraklar.items.find((x: DosyaEvraklarCevapRow) => x.turu == "Takip Talebi");
                if (takipTalebi) {
                    //Takip Talebi ve Ekleri (1)
                    let takipTalebiBlob = await app.$uyap.EvrakIndir().run({
                        dosyaId: dosya.dosyaId,
                        evrakId: takipTalebi.evrakId,
                        yargiTuru: 1
                    })
                    let parsedContent: any = await TakipSenkronize.parseContentXml(takipTalebiBlob);
                    let uyapTakipTalebiContent = UyapTakipTalebiContent.parse(parsedContent);
                    await app.$http.post('/api/v1/uyap-takip/', {
                        hash: uyapTakipTalebiContent.hash,
                        type: "uyap",
                        dosya: uyapTakipTalebiContent,
                        uyap_dosya_id: dosya.dosyaId,
                        status: 5,
                    });
                    //let response = await app.$http
                    console.log("created uyapTakipTalebiContent", uyapTakipTalebiContent);
                    key++;
                }
            }
        } catch (e) {
            throw new Error(e.message);
        }
    }

    async run(dosyaId: number): Promise<any> {
        let evraklar = await app.$uyap.DosyaEvraklar().run({
            dosyaId: dosyaId.toString()
        });
        console.log("evraklar", evraklar);
        let takipTalebi = evraklar.items.find((x: DosyaEvraklarCevapRow) => x.turu == "Takip Talebi");
        // @ts-ignore
        let odemeIcraEmri = evraklar.items.findLast((x: DosyaEvraklarCevapRow) => x.turu == "Ödeme İcra Emri");
        console.log("takipTalebi", takipTalebi);
        console.log("odemeIcraEmri", odemeIcraEmri);
        if (takipTalebi) {
            console.log("takiptalebi bulundu", takipTalebi);
            //Takip Talebi ve Ekleri (1)
            let takipTalebiBlob = await app.$uyap.EvrakIndir().run({
                dosyaId: dosyaId,
                evrakId: takipTalebi.evrakId,
                yargiTuru: 1
            })
            let content = await TakipSenkronize.parseContentXml(takipTalebiBlob);
            console.log("CONTENT", content);
            console.log("CONTENT", JSON.stringify(content));
        }
        /*else if(odemeIcraEmri){
            console.log("odemeIcraEmri bulundu",odemeIcraEmri);
            let blob = await app.$uyap.EvrakIndir().run({
                dosyaId:dosyaId,
                evrakId:odemeIcraEmri.evrakId,
                yargiTuru:1
            })
            let content = await TakipSenkronize.parseContentXml(blob);
            console.log("CONTENT",content);
            console.log("CONTENT",JSON.stringify(content));
        }

         */
    }

   static async blobToText(blob) {
        if (!(blob instanceof Blob)) {
            throw new TypeError("Parametre Blob olmalıdır");
        }

        return await blob.text();
    }

    static async getContentXmlFromZip(blob) {
        try {
            return  await JSZip.loadAsync(blob);
        }catch (e) {
            return false;
        }
    }

    static async parseContentXml(blob: Blob): Promise<any> {
        return new Promise(async (resolve, reject) => {
            //zipmi diye kontrol et
            try {
                let zip = await this.getContentXmlFromZip(blob);
                let xml = "";
                if(zip === false)
                    xml = await this.blobToText(blob);
                else{
                    xml = await zip.file("content.xml").async("string");
                }
                // @ts-ignore
                let startIndex = xml.indexOf("<data>") + 6;
                let endIndex = xml.indexOf("</data>");
                let xmlContentData = xml.substr(startIndex, endIndex - startIndex);
                xmlContentData = "<data>" + xmlContentData + "</data>";
                //console.log(xmlContentData);
                let parseString = xml2js.parseString;
                parseString(xmlContentData, {explicitArray: false}, (error: Error | null, result: any) => {
                    if (error) {
                        return reject(error);
                    }
                    return resolve(result.data);
                });

            } catch (e) {
                return reject(e);
            }
        })
    }

}
